import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "name", "value", "placeholder", "disabled", "readonly", "maxlength", "max"]

import {
  useAttrs,
  withDefaults,
  defineOptions,
} from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  type?: "text" | "number" | "tel" | "email" | "url" | "password" | "search";
  name?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  readonly?: boolean;
  maxlength?: number;
  max?: number;
  min?: number;
  pattern?: RegExp;
}

export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'input-field',
  props: {
    modifires: { type: [String, Array, Boolean] },
    type: { default: "text" },
    name: {},
    value: {},
    placeholder: {},
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    maxlength: {},
    max: {},
    min: {},
    pattern: {}
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props;





const attrs = useAttrs();


const handleInput = (e: Event) => {
  emit("update", (e.target as HTMLInputElement).value);
};

const defaultValue = () => {
  if (attrs.modelValue) {
    return attrs.modelValue;
  }
  return props.value;
};

const checkValue = (e: Event) => {
  (e.target as HTMLInputElement).value;
  if (props.type === "number") {
    if ((e as any).data === "e") {
      (e.target as HTMLInputElement).value = props.value;
      return;
    }
  }
  if (
    props.pattern &&
    !props.pattern.test((e.target as HTMLInputElement).value)
  ) {
    (e.target as HTMLInputElement).value = props.value;
    return;
  }
  if (
    (props.max || props.max === 0) &&
    Number((e.target as HTMLInputElement).value) > props.max
  ) {
    (e.target as HTMLInputElement).value = props.max.toString();
    emit("update", props.max.toString());
    return;
  }
  if (
    (props.min || props.min === 0) &&
    Number((e.target as HTMLInputElement).value) < props.min
  ) {
    (e.target as HTMLInputElement).value = props.min.toString();
    emit("update", props.min.toString());
    return;
  }
  emit("update", (e.target as HTMLInputElement).value);
};

const componentClass = () =>
  mapModifires(
    "input-field",
    mergeModifires(props.modifires, props.disabled && "disabled")
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("input", _mergeProps(_ctx.$attrs, {
      onBlur: handleInput,
      class: "input-field__input",
      type: _ctx.type,
      name: _ctx.name,
      value: defaultValue(),
      placeholder: _ctx.placeholder,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      maxlength: props.maxlength,
      max: props.max,
      onInput: checkValue
    }), null, 16, _hoisted_1)
  ], 2))
}
}

})